export { default } from './WindForecastGraphContainer';
